import React, { useState } from 'react';
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Avatar,
  Chip,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import {
  Visibility,
  Delete,
  People,
  Timer,
  CalendarMonth,
  WorkspacePremium,
  Verified,
  AccessTimeFilled,
  Edit,
  AutoAwesome,
} from '@mui/icons-material';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import ConfirmDialog from '../../components/base/ConfirmDialog'; // Vérifie bien le chemin vers ton dossier base
import { useNavigate } from 'react-router-dom';
const WorkshopGrid = ({ data, onDelete, onEdit }) => {
  // 1. États pour le modal de confirmation
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedWs, setSelectedWs] = useState(null);
  const navigate = useNavigate();
  // 2. Ouvrir le modal
  const handleDeleteClick = (ws) => {
    setSelectedWs(ws);
    setOpenConfirm(true);
  };

  // 3. Action de confirmation
  const handleConfirmDelete = async () => {
    if (selectedWs && selectedWs.id_ws) {
      // On appelle la fonction passée par le parent (Ateliers.jsx)
      await onDelete(selectedWs.id_ws);
    }
    // 🔥 ON FERME LE MODAL ICI
    setOpenConfirm(false);
    setSelectedWs(null);
  };
  if (data.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 10 }}>
        <Typography
          sx={{ color: '#A3AED0', fontSize: '1.1rem', fontWeight: '500' }}
        >
          Aucun atelier ne correspond à votre recherche.
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3} alignItems="stretch">
      {' '}
      {/* 1. Force l'alignement sur la rangée */}
      {data.map((ws) => {
        const isVIP = ws.is_accessible_participant === 1;
        const isPaid = ws.is_paid_ws === 1;
        const sessionDate = ws.session_date_ws
          ? new Date(ws.session_date_ws)
          : null;

        return (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            key={ws.id}
            sx={{
              display: 'flex',
              alignSelf: 'stretch',
            }}
          >
            {' '}
            {/* 2. Étire l'item */}
            <Card
              sx={{
                width: '100%',
                height: 420, // 🔥 FIX PRINCIPAL
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '24px',
                p: 1,
                overflow: 'hidden',
              }}
            >
              {/* --- IMAGE & OVERLAYS --- */}
              <Box sx={{ height: 160, flexShrink: 0, position: 'relative' }}>
                {ws.photo_ws ? (
                  <CardMedia
                    component="img"
                    height="100%"
                    image={`${process.env.REACT_APP_API_URL}/storage/workshop/${ws.photo_ws}`}
                    // Si l'image existe en base mais que le fichier est introuvable sur le serveur
                    onError={(e) => {
                      e.target.style.display = 'none'; // Cache l'image cassée
                      e.target.parentNode.style.background =
                        'linear-gradient(135deg, #4318FF 0%, #3311CC 100%)'; // Affiche le dégradé
                    }}
                    sx={{
                      objectFit: 'cover',
                      transition: 'transform 0.5s',
                      '&:hover': { transform: 'scale(1.1)' },
                    }}
                  />
                ) : (
                  /* ✨ CE QUI S'AFFICHE PAR DÉFAUT SI PAS D'IMAGE */
                  <Box
                    sx={{
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background:
                        'linear-gradient(135deg, #E9EDF7 0%, #DBE0EE 100%)', // Gris bleuté moderne
                    }}
                  >
                    <AutoAwesome
                      sx={{ fontSize: 40, color: '#A3AED0', opacity: 0.5 }}
                    />
                  </Box>
                )}

                {/* BADGE DE STATUT MODERNE (TOP GAUCHE) */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 12,
                    left: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.8,
                    bgcolor: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(4px)',
                    px: 1.2,
                    py: 0.4,
                    borderRadius: '20px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  }}
                >
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      bgcolor: ws.is_published_ws === 1 ? '#05CD99' : '#EE5D50',
                      boxShadow:
                        ws.is_published_ws === 1 ? '0 0 8px #05CD99' : 'none',
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '900',
                      color: '#1B254B',
                    }}
                  >
                    {ws.is_published_ws === 1 ? 'ACTIF' : 'BROUILLON'}
                  </Typography>
                </Box>
                {/* Badge PASS ABONNÉS - Effet Pulse */}
                {isVIP && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 12,
                      right: 12,
                      zIndex: 2,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: '20px',
                        animation: 'pulse-gold 2s infinite',
                        zIndex: -1,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        background:
                          'linear-gradient(135deg, #FFD700 0%, #F5AF19 100%)',
                        color: '#fff',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        boxShadow: '0 4px 15px rgba(245, 175, 25, 0.4)',
                      }}
                    >
                      <WorkspacePremium sx={{ fontSize: 14 }} />
                      <Typography
                        sx={{
                          fontSize: '9px',
                          fontWeight: '900',
                          letterSpacing: '0.5px',
                        }}
                      >
                        PASS ABONNÉS
                      </Typography>
                    </Box>
                  </Box>
                )}

                {/* Badge Format - Design Premium Glassmorphism */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 12,
                    left: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    bgcolor: 'rgba(255, 255, 255, 0.9)', // Fond blanc pur translucide
                    backdropFilter: 'blur(10px)', // Effet de flou haut de gamme
                    px: 1.5,
                    py: 0.6,
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    border: '1px solid rgba(255,255,255,0.3)',
                  }}
                >
                  {ws.format_ws === 'en_presentiel' ? (
                    <>
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          bgcolor: '#05CD99',
                          borderRadius: '50%',
                          animation: 'pulse-green 2s infinite',
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: '10px',
                          fontWeight: '800',
                          color: '#1B254B',
                          letterSpacing: '0.3px',
                        }}
                      >
                        PRÉSENTIEL
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          bgcolor: '#4318FF',
                          borderRadius: '50%',
                          animation: 'pulse-blue 2s infinite',
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: '10px',
                          fontWeight: '800',
                          color: '#1B254B',
                          letterSpacing: '0.3px',
                        }}
                      >
                        Atelier Zoom
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>

              {/* --- CONTENU --- */}
              <CardContent
                sx={{
                  p: 2.5,
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* TOP BLOCK (date + prix) */}
                <Box sx={{ minHeight: 70 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                  >
                    <Stack spacing={0.8}>
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        <CalendarMonth
                          sx={{ fontSize: 14, color: '#4318FF' }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            color: '#2B3674',
                            fontWeight: '800',
                            textTransform: 'capitalize',
                          }}
                        >
                          {sessionDate
                            ? format(sessionDate, 'eeee dd MMM', { locale: fr })
                            : 'À venir'}
                        </Typography>
                      </Stack>

                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 0.5,
                        }}
                      >
                        <AccessTimeFilled
                          sx={{ fontSize: 12, color: '#4318FF' }}
                        />
                        <Typography
                          sx={{
                            color: '#4318FF',
                            fontWeight: '900',
                            fontSize: '11px',
                          }}
                        >
                          {sessionDate ? format(sessionDate, 'HH:mm') : '--:--'}
                        </Typography>
                      </Box>
                    </Stack>

                    <Typography
                      sx={{
                        fontWeight: '900',
                        fontSize: '1.2rem',
                        lineHeight: 1,
                        minWidth: 60,
                        textAlign: 'right',
                      }}
                    >
                      {isPaid ? `${ws.price_ws}€` : 'OFFERT'}
                    </Typography>
                  </Stack>
                </Box>

                {/* TITLE BLOCK FIXE */}
                <Box
                  sx={{
                    height: 52,
                    display: 'flex',
                    alignItems: 'flex-start',
                    mb: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontWeight: '700',
                      color: '#1B254B',
                      lineHeight: 1.3,

                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {ws.title_ws}
                  </Typography>
                </Box>

                {/* STATS BLOCK FIXE */}
                <Box
                  sx={{
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <People sx={{ fontSize: 14, color: '#4318FF' }} />
                    <Typography variant="caption" sx={{ fontWeight: '700' }}>
                      {ws.capacity_ws} pl.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Timer sx={{ fontSize: 14, color: '#4318FF' }} />
                    <Typography variant="caption" sx={{ fontWeight: '700' }}>
                      {ws.duration_ws} min
                    </Typography>
                  </Box>
                </Box>

                {/* FOOTER AVEC INTERVENANT ET ACTIONS */}
                <Box
                  sx={{
                    mt: 'auto',
                    pt: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderTop: '1px solid rgba(224, 229, 242, 0.6)',
                    flexShrink: 0,
                  }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Box sx={{ position: 'relative' }}>
                      <Avatar
                        src={
                          ws.intervenant?.photo_user
                            ? `${process.env.REACT_APP_API_URL}/storage/workshop/${ws.intervenant.photo_user}`
                            : ''
                        }
                        sx={{
                          width: 32,
                          height: 32,
                          fontSize: '14px',
                          fontWeight: '700',
                          bgcolor: '#E9EDF7', // Couleur de fond si pas d'image
                          color: '#4318FF', // Couleur du texte (initiales)
                          boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
                        }}
                      >
                        {/* On affiche la première lettre du prénom si l'image est absente */}
                        {ws.intervenant?.prenom_user?.charAt(0).toUpperCase()}
                      </Avatar>

                      <Verified
                        sx={{
                          position: 'absolute',
                          bottom: -2,
                          right: -2,
                          fontSize: 12,
                          color: '#4318FF',
                          bgcolor: '#fff',
                          borderRadius: '50%',
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontWeight: '800',
                        color: '#1B254B',
                        fontSize: '11px',
                      }}
                    >
                      {ws.intervenant?.prenom_user} {ws.intervenant?.nom_user}
                    </Typography>
                  </Stack>

                  <Stack direction="row" spacing={0.8}>
                    <IconButton
                      onClick={() => navigate(`/ateliers/${ws.id_ws}`)}
                      sx={{ color: '#4318FF', bgcolor: '#F4F7FE' }}
                    >
                      <Visibility sx={{ fontSize: 16 }} />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => onEdit(ws)} // Envoie les infos au parent
                      sx={{ color: '#4318FF', bgcolor: '#F4F7FE', mx: 1 }}
                    >
                      <Edit sx={{ fontSize: 16 }} />
                    </IconButton>

                    <IconButton
                      onClick={() => handleDeleteClick(ws)}
                      sx={{ color: '#EE5D50', bgcolor: '#FFF5F5' }}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Stack>
                </Box>
                <ConfirmDialog
                  open={openConfirm}
                  title="Supprimer l'atelier"
                  message={`Êtes-vous sûr  de vouloir supprimer "${selectedWs?.title_ws}" ? Cette action est irréversible.`}
                  onConfirm={handleConfirmDelete} // ✨ 'onConfirm' au lieu de 'handleConfirm'
                  onCancel={() => {
                    // ✨ 'onCancel' au lieu de 'handleClose'
                    setOpenConfirm(false);
                    setSelectedWs(null);
                  }}
                />

                {/* DATE DE CRÉATION - TOUT EN BAS */}
                <Typography
                  sx={{
                    fontSize: '9px',
                    color: '#A3AED0',
                    fontStyle: 'italic',
                    display: 'flex',
                    justifyContent: 'left', // Centre la date pour un look plus classe
                    mt: 0.5,
                  }}
                >
                  Publié le{' '}
                  {ws.created_at
                    ? format(new Date(ws.created_at), 'dd/MM/yyyy')
                    : '--/--'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
      <style>
        {`
          @keyframes pulse-gold {
            0% { box-shadow: 0 0 0 0 rgba(245, 175, 25, 0.7); }
            70% { box-shadow: 0 0 0 10px rgba(245, 175, 25, 0); }
            100% { box-shadow: 0 0 0 0 rgba(245, 175, 25, 0); }
          }
        `}
      </style>
    </Grid>
  );
};

export default WorkshopGrid;
